<!-- HEAD -->
<app-main-head [breadcrumbItems]="breadcrumbItems" [isSearchRequired]="false" [mainTitle]="'NAVBAR_TAB.PROCEDURE_AZIENDALI'"
  [isRightPanelVisible]="false">
</app-main-head>
<!-- END HEAD -->
<!-- ALL -->
<app-main-all-body id="all-proc-aziend" [typology]="'prod_az'" [mainTitle]="''" [bodyList]="procAziendList">
</app-main-all-body>
<!-- END ALL -->